// src/components/ui/CardTitleWithFlag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import { Form } from 'antd';
import CountryFlag from './CountryFlag';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const WRAPPER_STYLE = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
};

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
// CardTitleWithFlag - Card title with country flag (SVG) on the right.
// Uses Form.useWatch internally so only this component re-renders on country change.
const CardTitleWithFlag = ({
  title,
  watchField = 'countryCode',
  flagSize = 32,
  showFlag = false,
}) => {
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  const { form } = useSimpleFormContext();

  // PERFORMANCE: Form.useWatch is isolated in this component only
  const countryCode = Form.useWatch(watchField, form);

  // 9. UI
  return (
    <div style={WRAPPER_STYLE}>
      <div className="text-muted">{title}</div>

      {showFlag && countryCode && (
        <CountryFlag
          countryCode={countryCode}
          size={flagSize}
          style={{ marginLeft: 8 }}
        />
      )}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardTitleWithFlag;
